import { useQuery } from "@tanstack/react-query";
import { HealthResponse } from "@oracus/shared/api/health";
import { apiClient } from "./client.ts";

export function useHealth() {
  return useQuery({
    queryKey: ["health"],
    queryFn: () => apiClient.get("/api/health", HealthResponse),
    refetchInterval: 5_000,
  });
}
